/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SeriesRepetitionEnum } from './seriesRepetitionEnum';


/**
 * Serializer for the AppointmentBlockerSeries model.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentBlockerSeries { 
    readonly id: number;
    /**
     * Die Anzahl der Blocker in der Serie. Muss mindestens 2 betragen.
     */
    blockerAmount?: number | null;
    /**
     * Startdatum der Serie. Dies ist das Datum des ersten Blockers.
     */
    startDate: string;
    /**
     * Das Enddatum der Serie. Dies ist das Datum des letzten Blockers.
     */
    endDate?: string | null;
    readonly repetitionType: SeriesRepetitionEnum;
    /**
     * Der Abstand in Wochen zwischen den einzelnen Blockern. Der Wert 1 bedeutet jede Woche, der Wert 2 bedeutet alle zwei Wochen usw. Der Wert muss mindestens 1 betragen.
     */
    weekInterval: number;
}
export namespace AppointmentBlockerSeries {
}

export const AppointmentBlockerSeries_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlockerSeries_blockerAmount_Validators: ValidatorFn[] =
    [  Validators.min(2), Validators.max(2147483647),];

export const AppointmentBlockerSeries_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlockerSeries_endDate_Validators: ValidatorFn[] =
    [ ];

export const AppointmentBlockerSeries_repetitionType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlockerSeries_weekInterval_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.min(1), Validators.max(2147483647),];


